import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { ICapability } from "@skills-app/models/capability";

@Component({
  standalone: false,
  selector: "app-capability-list",
  templateUrl: "./capability-list.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./capability-list.component.css"],
})
export class CapabilityListComponent {
  @Input() capabilities: ICapability[] = [];

  @Output() capabilitySelected = new EventEmitter<ICapability>();

  selectedCapability?: ICapability;

  selectCapability(capability: ICapability) {
    this.selectedCapability = capability;
    this.capabilitySelected.emit(capability);
  }
}
